module.exports = {
  pathPrefix: '',
  siteUrl: 'https://www.oriechinedu.com',
  siteTitle: 'Nedsoft',
  siteDescription: 'A corner for techies',
  author: 'iam_nedsoft',
  postsForArchivePage: 3,
  defaultLanguage: 'en',
  disqusScript: 'https://https-www-oriechinedu-com.disqus.com/embed.js',
  pages: {
    home: '/',
    posts: 'posts',
    portfolio: 'portfolio',
    tag: 'tag',
    archive: 'archive',
    success: 'success',
  },
  social: {
    github: 'https://github.com/nedssoft',
    linkedin: 'https://www.linkedin.com/in/oriechinedu/',
    twitter: 'https://www.twitter.com/iam_nedsoft',
  },
  tags: {
    angular: {
      description: 'Angular is an open source web application platform.',
    },
    electron: {
      description:
        'Electron is a framework for building cross-platform desktop applications with web technology.',
    },
    javascript: {
      description:
        'JavaScript is an object-oriented programming language used alongside HTML and CSS to give functionality to web pages.',
    },
    laravel: {
      description:
        'Laravel is a PHP framework for building web applications following the MVC pattern.',
    },
    nodejs: {
      name: 'Node.js',
      description:
        'Node.js is a tool for executing JavaScript in a variety of environments.',
    },
    rxjs: {
      name: 'RxJS',
      description:
        'RxJS is a library for reactive programming using Observables, to make it easier to compose asynchronous or callback-based code.',
    },
    sass: {
      description: 'Sass is a stable extension to classic CSS.',
    },
    typescript: {
      description:
        'TypeScript is a typed superset of JavaScript that compiles to plain JavaScript.',
    },
    react: {
      description:
        'React is an open source JavaScript library used for designing user interfaces.',
    },
    vuejs: {
      name: 'Vue.js',
      description:
        'Vue.js is a JavaScript framework for building interactive web applications.',
    },
    express: {
      name: 'Express.js',
      description: 'Fast, unopinionated, minimalist web framework for Node.js',
    },
    heroku: {
      name: 'Heroku',
      description:
        'Heroku is a platform as a service (PaaS) that enables developers to build, run, and operate applications entirely in the cloud.',
    },
    docker: {
      name: 'Docker',
      description:
        'Docker is an open-source platform that makes it possible for software developers to Build, Ship, and Run any App anywhere',
    },
    devOps: {
      name: 'DevOps',
      description: '',
    },
    postgres: {
      name: 'Postgres',
      description: '',
    },
    testing: {
      name: 'Testing',
      description: '',
    },
    travis: {
      name: 'Travis',
      description: '',
    },
    coveralls: {
      name: 'Coveralls',
      description: '',
    },
    email: {
      name: 'Email',
      description: '',
    },
    sendgrid: {
      name: 'SendGrid',
      description: '',
    },
    mailgen: {
      name: 'Email template',
      description: '',
    },
    css: {
      name: 'CSS',
      description: '',
    },
    mediaQuery: {
      name: 'Media Query',
      description: '',
    },
     slack: {
      name: 'Slack',
      description: '',
    },
    git: {
      name: 'Git',
      description: '',
    },
    devops: {
      name: 'Devops',
      description: '',
    },
    aws: {
      name: 'AWS',
      description: '',
    },
    graphql: {
      name: 'GraphQL',
      description: '',
    },
    sequelize: {
      name: 'Sequelize',
      description: '',
    },
  },
}
